import { render, staticRenderFns } from "./productionReturn-add-or-update.vue?vue&type=template&id=0964f6f2&scoped=true"
import script from "./productionReturn-add-or-update.vue?vue&type=script&lang=js"
export * from "./productionReturn-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./productionReturn-add-or-update.vue?vue&type=style&index=0&id=0964f6f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0964f6f2",
  null
  
)

export default component.exports